// <- TaskManagment.js
import React, { useState, Fragment,useEffect  } from "react";
import { Button, ListGroup, ListGroupItem } from "reactstrap";
import TableWithSortPagtn from "../../common/TableWithSortPagtnWithTotBillable";
import DropDownActions from "../../common/DropDownActions";
import moment from 'moment';
const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let sumhours=0;
let sumbillable=0;
let maxwidth="80vw";
const ListWorkSummaryView = React.memo(
  ({
    handleAddEditTaskForm,
    handleSelectedTask,
    handleOpenCalendar,
    handleDelTask,
    empTask,
    taskProjectInfo,
    handleToggleAllTaskCalendar,
    getAllTaskOfEmployee,
    handleUnlockRequestForm
  }) => {
    const [thead] = useState([
     
      "Project",
      
       "Actual Effort Spent(In Hours)",
      
       

    ]);
    const [trow, setTrow] = useState([]);
    const [activeTask, setActiveTask] = useState(0);
   
    const handleOnclickSelectedTask = React.useCallback(
      (task, i) => {
        setActiveTask(i);
        handleSelectedTask(task);
      },
      [handleSelectedTask]
    );

   

    const DelTask=React.useCallback(
      (delId)=>{
      handleDelTask(delId);
    },[empTask]);



    useEffect(() => {
      sumhours=0;
      sumbillable=0;
      empTask.map((el) =>{
        sumhours = sumhours+el.hoursSpent;
        sumbillable =sumbillable+el.hoursBillable;
      });
      let trow = empTask.map((el) => ({
        Project: <div style={{width:'100px'}}>{el.projectName === null ? "" : el.projectName}</div>,
       "Hours Spent": <div style={{width:'120px'}}>{el.hoursSpent === null ? "" : el.hoursSpent}</div>,
       
     
      }));
    
      setTrow(trow);
    }, []);
    
    return (
      <Fragment>
        <div className="fixed-header">
          <div>
        
            &nbsp;
          
            <div className="d-inline float-right ">
 
            </div>
          </div>
        </div>
        {/*  style={{ maxWidth: maxwidth, overflowY: "auto" }} */}
        <div className="">
      <TableWithSortPagtn thead={thead} trow={trow} pageSize={5} sumhours={sumhours} sumbillable={sumbillable}></TableWithSortPagtn>
    </div>
     
      </Fragment>
    );
  }
);

export default ListWorkSummaryView;
